var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage42(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171275414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_ii_10589_4122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.861 19.1843C15.2501 21.3413 13.4285 23.4755 10.7922 23.9511C8.15589 24.4268 5.70327 23.0638 5.31409 20.9068C4.92492 18.7499 6.74657 16.6157 9.38287 16.14C12.0192 15.6644 14.4718 17.0274 14.861 19.1843Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36004 3.59865L12.4022 5.55899L14.7824 18.751L12.1787 19.2208L9.36004 3.59865Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5007 10.499C13.6343 9.20322 11.2284 8.60347 10.2773 7.44063L9.36004 3.59865C12.3977 3.05058 12.0007 4.99904 18.5007 8.99904C20.2985 11.1474 20.0036 13.5117 19.2823 15.3138C19.0677 15.8497 18.1946 15.4734 18.1763 14.8964C18.1281 13.3797 17.5303 11.6702 15.5007 10.499Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_ii_10589_4122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1046 26.5755C23.9385 28.5648 21.8328 30.013 19.4013 29.81C16.9699 29.607 15.1334 27.8297 15.2995 25.8404C15.4656 23.851 17.5713 22.4028 20.0028 22.6058C22.4342 22.8088 24.2707 24.5861 24.1046 26.5755Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2647 27.5755C35.0986 29.5648 32.9929 31.013 30.5615 30.81C28.13 30.607 26.2936 28.8297 26.4597 26.8404C26.6257 24.851 28.7315 23.4028 31.1629 23.6058C33.5944 23.8088 35.4308 25.5861 35.2647 27.5755Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9362 11.5664L25.1504 14.0082L24.1346 26.1752L21.7332 25.9747L22.9362 11.5664Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0963 12.5664L36.3106 15.0082L35.2948 27.1752L32.8934 26.9747L34.0963 12.5664Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.983 11L36.5448 12.134L36.2115 16.1201L22.6497 14.9861L22.983 11Z",
    fill: "#3A3A3A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_10589_4122",
    x: 4.26172,
    y: 2.50781,
    width: 16.582,
    height: 22.5371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10589_4122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10589_4122",
    result: "effect2_innerShadow_10589_4122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_10589_4122",
    x: 14.2891,
    y: 10,
    width: 23.2539,
    height: 21.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10589_4122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10589_4122",
    result: "effect2_innerShadow_10589_4122"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage42);
export default __webpack_public_path__ + "static/media/page4_2.7d97d7dba4b38870206e9d85581dfd28.svg";
export { ForwardRef as ReactComponent };